/* Lazurd: paid chocolate-cut text on cakes. Adds the cake and the add-on product to the bag together. */
(function () {
  function init(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var chk = el.querySelector('.lzd-caketext__check');
    var field = el.querySelector('.lzd-caketext__field');
    var inp = el.querySelector('.lzd-caketext__input');
    if (!chk || !field || !inp) return;
    chk.addEventListener('change', function () {
      field.hidden = !chk.checked;
      inp.disabled = !chk.checked;
      if (chk.checked) inp.focus();
    });
    var form = document.getElementById(el.dataset.form);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!chk.checked) return;
      var text = (inp.value || '').trim();
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!text) { inp.focus(); inp.classList.add('is-error'); return; }
      var fd = new FormData(form);
      var id = fd.get('id');
      var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
      var props = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      props['Text on the cake'] = text;
      var items = [
        { id: id, quantity: qty, properties: props },
        { id: el.dataset.addonId, quantity: qty, properties: { 'For': el.dataset.product, 'Text on the cake': text } }
      ];
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { window.location.href = el.dataset.cartUrl; })
        .catch(function () { window.location.href = el.dataset.cartUrl; });
    }, true);
  }
  function scan() { document.querySelectorAll('[data-lzd-caketext]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();